import React, {useState, useEffect, useRef} from 'react';
import ActionItemCreate from './ActionItemCreate.mjs';
import TeamCard from './TeamCard.mjs';
import TeamActionItemList from './TeamActionItemList.mjs';
import TeamMemberCard from './TeamMemberCard.mjs';
import TeamNewMembersCard from './TeamNewMembersCard.mjs';
import TeamShortTermGoalsCard from './TeamShortTermGoalsCard.mjs';
import TeamHistoryCard from './TeamHistoryCard.mjs';
import TeamSettingsCard from './TeamSettingsCard.mjs';
import TeamListInformation from './TeamListInformation.mjs';

import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function TeamColumn() 
{
    const { user_id, team, team_members_list, setTeamMembersList, setTeamDisplayRefresh } = useCTAL();
    const [display_type, setDisplayType] = useState("action-item-list");
    const [display, setDisplay] = useState(<></>);
 
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const initRef = useRef("");

    useEffect(() =>
    {
        if (!team) return;
        
        if (initRef.id == team.TeamID) return;
        initRef.id = team.TeamID;

        show_display(display_type, true); //Need to reset team and user_id on Context value change
        if (DEBUG) console.log(`TeamColumn** - user_id from Context: ${user_id}, team_id from Context: ${team.TeamID}`);
        //SSS setTeamDisplayRefresh(false); //Team is reloaded on setTeamDisplayRefresh(true);
        if (DEBUG) console.log(`TeamColumn**** - setTeamDisplayRefresh: false`);
    }, [ user_id, team ]);

    const show_display = (d_type, reset=false) => { 

        if ((display_type == d_type) && (!reset))
            return;

        switch (d_type)
        {
            case "action-item-list":
            default:
                setDisplay( <> <TeamActionItemList team_id={team.TeamID} /> </> ); 
                break;
            case "members":
                setDisplay( <> <TeamMemberCard team_id={team.TeamID} /> </> ); 
                break;
            case "add-members":
                setDisplay( <> <TeamNewMembersCard team={team} /> </> ); 
                break;
            case "team-invitations":
                setDisplay( <> <TeamNewMembersCard team={team} show_invitations={true} /> </> ); 
                break;
            case "short-term-goals":
                setDisplay( <> <TeamShortTermGoalsCard /> </> ); 
                break;
            case "team-history":
                setDisplay( <> <TeamHistoryCard team_id={team.TeamID} /> </> ); 
                break;
            case "team-billing":
                setDisplay( <> <p>Display Team Billing</p> </> ); 
                break;
            case "team-settings":
                setDisplay( <> <TeamSettingsCard team={team} /> </> ); 
                break;
            case "team-information":
                setDisplay( <> <TeamListInformation /> </> ); 
                break;
        }

        setDisplayType(d_type);
    }

    return (
        <>
            <ActionItemCreate show_display={show_display} />
            <TeamCard show_display={show_display}/>
            {display}
        </>
    );
}

/*
    9/5/2023 Removed Action-Item List Toolbar for Beta Release
    setDisplay( <> <ActionItemListToolbar /> <TeamActionItemList team_id={team.TeamID} /> </> ); 
*/